module.exports = __webpack_public_path__ + "static/media/link.dc778064.png";